import {
  CREATE_ACCOUNT_REQUEST,
  CREATE_ACCOUNT_SUCCESS,
  CREATE_ACCOUNT_FAILURE,
  CONFIRM_SMS_REQUEST,
  CONFIRM_SMS_SUCCESS,
  CONFIRM_SMS_FAILURE,
  TO_CONFIRM_SMS,
  RESET_REGISTRATION_STATES,
} from './registrationTypes';

const initialState = {
  requestingCreateAccount: false,
  step: 1,
  confirmSMSIsSuccessful: false,
  requestingConfirmSMS: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case CREATE_ACCOUNT_REQUEST:
      return {
        ...state,
        requestingCreateAccount: true,
      };
    case CREATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        // requestingCreateAccount: false,
        createAccountIsSuccessful: true,
      };
    case CREATE_ACCOUNT_FAILURE:
      return {
        ...state,
        requestingCreateAccount: false,
      };
    case CONFIRM_SMS_REQUEST:
      return {
        ...state,
        requestingConfirmSMS: true,
      };
    case CONFIRM_SMS_SUCCESS:
      return {
        ...state,
        requestingConfirmSMS: false,
        confirmSMSIsSuccessful: true,
      };
    case CONFIRM_SMS_FAILURE:
      return {
        ...state,
        requestingConfirmSMS: false,
      };
    case TO_CONFIRM_SMS:
      return {
        ...state,
        step: 2,
      };
    case RESET_REGISTRATION_STATES:
      return initialState;
    default:
      return state;
  }
}
